import type Shipment from '~/types/Shipment';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type ShipmentsState = {
  readonly data: { [shipmentObjectId: string]: Readonly<Shipment> };
  readonly loadState: { [shipmentObjectId: string]: boolean };
};

const initialState: ShipmentsState = {
  data: {},
  loadState: {},
};

const reducer = (state: ShipmentsState = initialState, action: ActionTypes): ShipmentsState => {
  switch (action.type) {
    case ActionKeys.SHIPMENT_FETCH:
      return {
        ...state,
        loadState: {
          ...state.loadState,
          [action.shipmentId]: true,
        },
      };
    case ActionKeys.SHIPMENT_FETCH_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.shipment.objectId]: action.payload.shipment,
        },
        loadState: {
          ...state.loadState,
          [action.shipmentId]: false,
        },
      };
    // Implement error handling
    case ActionKeys.SHIPMENT_FETCH_ERROR:
      return {
        ...state,
        loadState: {
          ...state.loadState,
          [action.payload.shipmentObjectId]: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
